module.exports = __webpack_public_path__ + "img/second_trophy.14ae3317.svg";